import { IEntriesKnisotItem } from '../../../../../../../modules/API/Knisot/models/entrie'

/**
 * Достаёт из ответа `createDetailsKnisa` строки, которые только что создали.
 *
 * Сервер возвращает ВЕСЬ список деталей теуды, отсортированный по `DetailNum`
 * по убыванию: индекс 0 — самая свежая строка. Поэтому созданные строки — это
 * первые `payload.length` записей с тем же ключом товара; брать их по фиксированному
 * индексу нельзя, оттуда и приходили чужие значения.
 *
 * Возвращает массив в том же порядке — по убыванию `DetailNum`, то есть
 * ПОСЛЕДНИЙ элемент это оригинал (у него наименьший номер), а перед ним копии.
 */
export const pickCreatedDetails = (
  payload: IEntriesKnisotItem[],
  details: IEntriesKnisotItem[],
): IEntriesKnisotItem[] => {
  const sample = payload[0]
  if (!sample) return []

  return details
    .filter(
      (item) =>
        item.ProductID === sample.ProductID &&
        item.VarietyID === sample.VarietyID &&
        item.SizeNum === sample.SizeNum,
    )
    // Не полагаемся на порядок ответа — сортируем сами.
    .sort((a, b) => b.DetailNum - a.DetailNum)
    .slice(0, payload.length)
}

export default pickCreatedDetails
